import ApiService from './service';
import * as http from './http';

export class BenchEmployeeService extends ApiService {

    async getAllBenchEmployeeRecords(request) {
        const { resource, ...params } = request;
        const url = `${this.apiDomain}/${resource}`;
        try {
            const response = await http.get(url, this.store, { params });
            return { data: response.data };
        } catch (error) {
            console.error("❌ [GET] Error fetching bench employee records:", error);
            return { data: [] };
        }
    }

    async getBenchEmployeeRecordById(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        try {
            const response = await http.get(url, this.store);
            return { data: response.data };
        } catch (error) {
            console.error("❌ [GET] Error fetching bench employee by ID:", error);
            return { data: null };
        }
    }

    async getBenchEmployeeRecordByEmail(request) {
        const url = `${this.apiDomain}/${request.resource}?email=${encodeURIComponent(request.email)}`;
        try {
            const response = await http.get(url, this.store);
            return { data: response.data };
        } catch (error) {
            console.error("❌ [GET] Error fetching bench employee by Email:", error);
            return { data: null };
        }
    }

    async postBenchEmployeeRecord(request, data) {
        const url = `${this.apiDomain}/${request.resource}`;
        try {
            const response = await http.post(url, data, this.store);
            return response;
        } catch (error) {
            console.error("❌ [POST] Error creating bench employee record:", error);
            return null;
        }
    }

    async updateBenchEmployeeRecord(request, data) {
        const url = `${this.apiDomain}/${request.resource}`;
        try {
            const response = await http.put(url, data, this.store);
            return response;
        } catch (error) {
            console.error("❌ [PUT] Error updating bench employee record:", error);
            return null;
        }
    }

    async updateBenchStartDate(request, data) {
        const url = `${this.apiDomain}/${request.resource}`;
        try {
            const response = await http.put(url, data, this.store);
            return response;
        } catch (error) {
            console.error("❌ [PUT] Error updating bench start date:", error);
            return null;
        }
    }

    async deleteBenchEmployeeRecord(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        try {
            const response = await http.remove(url, this.store);
            return response;
        } catch (error) {
            console.error("❌ [DELETE] Error deleting bench employee record:", error);
            return null;
        }
    }

    async softDeleteBenchEmployeeRecord(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const data = { isdeleted: true };
        try {
            const response = await http.patch(url, data, this.store);
            return response;
        } catch (error) {
            console.error("❌ [PATCH] Error soft deleting bench employee record:", error);
            return null;
        }
    }


    async getFilterOptions() {
        const url = `${this.apiDomain}/api/benchemployees`; 
        try {
            const response = await http.get(url, this.store);
            return { data: response.data };
        } catch (error) {
            console.error("❌ [GET] Error fetching filter options:", error);
            return { data: [] }; 
        }
    }
}
